import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './recommendation-document.controller';
import directive from './recommendation-document.directive';
import editRecommendationDocumentDialog from './dialog.editRecommendationDocumentDialog';

export default angular.module('app.components.advisory.auditTrail.recommendationDocument', [
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  editRecommendationDocumentDialog,
])
  .directive('amRecommendationDocument', directive)
  .controller('RecommendationDocumentController', controller)
  .name;

console.log('app.components.advisory.auditTrail.recommendationDocument created');
